import { Button } from '../ui/button'
import { Fragment, useEffect, useRef, useState } from 'react'
import { dispatch, useSelector } from '@/lib/store'
import { updateCartData } from '@/lib/reducers/cartReducer'
import { ShoppingCart } from 'lucide-react'

const ViewCartToast = ({ open = false, close }: any) => {
  const cartState: any = useSelector((state) => state.cart) || {}
  const packageState = useSelector((state) => state.package) || {}

  const [showToast, setShowToast] = useState(open)
  const [isFading, setIsFading] = useState(false)

  const modalWasOpenBeforeToast = useRef(packageState.modalIsOpen)

  useEffect(() => {
    if (showToast) {
      const fadeTimeout = setTimeout(() => {
        setIsFading(true)
      }, 4000)

      const hideTimeout = setTimeout(() => {
        setShowToast(false)
        if (!modalWasOpenBeforeToast.current) {
          close()
        }
      }, 5000)

      return () => {
        clearTimeout(fadeTimeout)
        clearTimeout(hideTimeout)
      }
    }
  }, [showToast])

  return (
    <Fragment>
      {showToast && (
        <Fragment>
          <div
            className={`flex gap-2 items-center justify-between py-3 px-5 rounded-full bg-primary-950 shadow-elevation5 w-fit mx-auto min-w-[300px] border border-solid border-white-4 toast ${
              isFading ? 'fade-out' : ''
            }`}
          >
            <p className="text-white-100 text-label-lg max-w-[200px] truncate">
              Adding for{' '}
              <span className="text-primary-300">
                {cartState?.activePatientDetailDto?.firstName}
              </span>
            </p>
            <Button
              className="p-0 m-0 bg-transparent shadow-none text-secondary-400 text-label-sm flex items-center gap-2"
              onClick={() =>
                dispatch(updateCartData({ ...cartState, modalIsOpen: true }))
              }
            >
              View Cart <ShoppingCart size={16} className="text-secondary-400" />
            </Button>
          </div>
        </Fragment>
      )}
    </Fragment>
  )
}

export default ViewCartToast
